import { isPartnerWinery } from '@helpers/winery';
import { RubyLibCheckoutPrice, RubyLibMerchant } from '@webtypes/rubyLibApi';
import { RubyLibFullWinery } from '@webtypes/rubyLibApi';
import React from 'react';
import { createPriceClick } from 'vivino-js/api/prices';

import ShopPresentational from './Shop.presentational';

interface ShopProps {
  vintageId: number;
  merchant: RubyLibMerchant;
  price: RubyLibCheckoutPrice;
  winery?: RubyLibFullWinery;
}

const Shop = ({ merchant, price, vintageId, winery }: ShopProps) => {
  const handleClickPPC = () => {
    createPriceClick({ priceId: price.id });
  };

  const isSponsored = isPartnerWinery(winery);

  return (
    <ShopPresentational
      merchant={merchant}
      onClickPPC={handleClickPPC}
      price={price}
      vintageId={vintageId}
      wineryId={winery?.id}
      sponsored={isSponsored}
    />
  );
};

export default Shop;
